import React from 'react'
import { LayoutProps } from '../../../common.interface'

function AuthContainer(props:LayoutProps) {
  return (
    <div className='flex flex-col sm:flex-none sm:w-96  m-auto p-10 rounded bg-authbackground-color  border border-primary-color'>{props.children}</div>
  )
}

export default AuthContainer